import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setIsLoading } from "../../redux/layout_slice";
import { chapterEndPoint, chapterListEndPoint } from "../../service/api_endpoints";
import { deleteAxiosWithToken, getAxiosWithToken, putAxiosWithToken } from "../../service/axios_service";
import Loading from "../../session/Loading";
import ResponsivePagination from "react-responsive-pagination";
import { Description, Dialog, DialogPanel, DialogTitle } from '@headlessui/react';
import toast from 'react-hot-toast';
import { useNavigate } from "react-router-dom";
import GroupsList from "../create_chapter/groups_list";

export default function Chapters() {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { isLoading } = useSelector((state) => state.layoutSlice);

    const [tableData, setTableData] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [tableFilters, setTableFilters] = useState({
        search: "",
        page: 1,
        items_per_page: 10
    })
    const [isDeleteOpen, setIsDeleteOpen] = useState(false);
    const [isDeleteLoading, setIsDeleteLoading] = useState(false);
    const [deleteChapterValue, setDeleteChapterValue] = useState(null)

    // Add Groups Modal state
    const [isAddGroupOpen, setIsAddGroupOpen] = useState(false);
    const [targetChapter, setTargetChapter] = useState(null);
    const [existingGroupsList, setExistingGroupsList] = useState([]);
    const [existingGroupsLoading, setExistingGroupsLoading] = useState(false);
    const [selectedNewGroupList, setSelectedNewGroupList] = useState([]);
    const [isSavingNewGroups, setIsSavingNewGroups] = useState(false);

    useEffect(() => {
        getChaptersList()
    }, [tableFilters])

    const getChaptersList = async () => {
        dispatch(setIsLoading(true))
        let response = await getAxiosWithToken({
            url: `${chapterListEndPoint}?search=${tableFilters.search}&items_per_page=${tableFilters.items_per_page}&page=${tableFilters.page}`,
        })

        if (response != null) {
            setTableData(response.data.list)
            setTotalPages(response.data.total_pages)
            dispatch(setIsLoading(false))
        }
    }

    const entriesHandler = (value) => {
        setTableFilters((prevState) => ({
            ...prevState,
            items_per_page: value,
        }))
    }

    const handleOpenAddGroupModal = async (item) => {
        setTargetChapter(item);
        setSelectedNewGroupList([]);
        setExistingGroupsList([]);
        setIsAddGroupOpen(true);
        setExistingGroupsLoading(true);

        let response = await getAxiosWithToken({
            url: `${chapterEndPoint}?id=${item.id}`
        });

        setExistingGroupsLoading(false);
        if (response != null && response.data) {
            setExistingGroupsList(response.data.group_details || []);
        }
    }

    const deleteChapter = async (id) => {
        setIsDeleteLoading(true);
        let response = await deleteAxiosWithToken({
            url: `${chapterEndPoint}?id=${id}`
        })

        if (response != null) {
            setIsDeleteOpen(false)
            setDeleteChapterValue(null)
            setIsDeleteLoading(false);

            toast.success(response.message)
            getChaptersList()
        }
    }

    const handleAddGroupsSubmit = async () => {
        if (!targetChapter || !selectedNewGroupList || selectedNewGroupList.length === 0) {
            toast.info("Please select at least 1 group to add!");
            return;
        }

        setIsSavingNewGroups(true);

        const tempGroupIds = selectedNewGroupList.map(item => item.id);

        const body = {
            id: targetChapter.id,
            add_group: tempGroupIds
        };

        const response = await putAxiosWithToken({
            url: chapterEndPoint,
            body: body
        });

        setIsSavingNewGroups(false);

        if (response != null) {
            toast.success(response.message || "Groups added successfully!");
            setIsAddGroupOpen(false);
            setTargetChapter(null);
            setSelectedNewGroupList([]);
            getChaptersList();
        }
    }

    return (
        <>
            <div>
                <div className='my-[10px] flex items-center justify-between gap-4 flex-wrap'>
                    <input type='text' name='search' id='search' onChange={(e) => {
                        setTableFilters((prevState) => ({
                            ...prevState,
                            search: e.target.value,
                        }))
                    }} className='text-sm bg-input-gray rounded focus:outline-primary w-[300px] px-[15px] py-[10px]' placeholder="search" />

                    <button
                        onClick={() => navigate('/create-fav-group')}
                        className="bg-primary text-white font-semibold text-sm px-[16px] py-[10px] rounded hover:bg-primary-dark transition flex items-center gap-2"
                    >
                        + Create Fav Group
                    </button>
                </div>
            </div>
            <div className="w-full">
                <table className="w-full">
                    <thead className="bg-light-gray text-white">
                        <tr>
                            <th className="p-[10px] text-left">S No</th>
                            <th className="p-[10px] text-left">Fav Group Name</th>
                            <th className="p-[10px] text-left">Group Count</th>
                            <th className="p-[10px] text-left">Contact Count</th>
                            <th className="p-[10px] text-left">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            isLoading ? <tr className=""><td colSpan={5}><div className="w-fit mx-auto py-5"><Loading /></div></td></tr> : tableData.map((item, index) => (
                                <tr key={index} className={`${index % 2 != 0 ? "bg-input-gray" : ""} border-b`}>
                                    <td className="p-[10px]">{index + 1}</td>
                                    <td className="p-[10px]">{item.chapter_name}</td>
                                    <td className="p-[10px]">{item.group_count}</td>
                                    <td className="p-[10px]">{item.contact_count}</td>
                                    <td className="p-[10px]">
                                        <div className="flex items-center gap-3">
                                            {/* Add More Groups (+) Icon Button */}
                                            <button
                                                title="Add More Groups"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleOpenAddGroupModal(item);
                                                }}
                                                className="bg-primary hover:bg-primary-dark text-white rounded p-1 flex items-center justify-center"
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                                    <line x1="12" y1="5" x2="12" y2="19"></line>
                                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                                </svg>
                                            </button>

                                            {/* View Details Eye Icon Button */}
                                            <button
                                                title="View Fav Group Details"
                                                onClick={(e) => {e.preventDefault(); navigate('/fav-group/'+item.id)}}
                                            >
                                                <span className="i-bx-show-alt w-6 h-6"></span>
                                            </button>

                                            {/* Delete Trash Icon Button */}
                                            <button
                                                title="Delete Fav Group"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setIsDeleteOpen(true);
                                                    setDeleteChapterValue(item)
                                                }}
                                            >
                                                <span className="i-fluent-delete-12-filled w-6 h-6"></span>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </div>

            <div className="my-[5px]">
                <div className='flex justify-between min-[500px]:flex gap-5'>
                    <div className='max-[499px]:mb-[15px] flex flex-wrap gap-3 items-center'>
                        <p>Entries</p>
                        <select value={tableFilters.items_per_page} onChange={(e) => entriesHandler(e.target.value)} className='border rounded-md w-[50px] font-400 text-[15px] p-[5px] outline-primary bg-white'>
                            {[10, 20, 30, 40, 50].map((limit) => (
                                <option key={limit} value={limit}>
                                    {limit}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="w-[50%] flex justify-end gap-[5px]">
                        <ResponsivePagination
                            total={totalPages}
                            current={tableFilters.page}
                            onPageChange={page => {
                                setTableFilters((prevState) => ({
                                    ...prevState,
                                    page: page
                                }))
                            }}
                            previousClassName='text-black bg-white'
                            previousLabel='<'
                            nextLabel='>'
                        />
                    </div>
                </div>
            </div>

            {/* Delete Fav Group Modal */}
            <Dialog open={isDeleteOpen} onClose={() => setIsDeleteOpen(false)} className="relative z-50">
                <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex w-screen items-center justify-center p-4">
                    <DialogPanel className="max-w-lg space-y-4 border bg-white p-12 rounded-lg shadow-xl">
                        <DialogTitle className="font-bold text-xl">Delete Fav Group</DialogTitle>
                        <Description className="text-gray-600">This will permanently delete the fav group</Description>
                        <p>Are you sure you want to delete the fav group?</p>
                        <div className="flex gap-4">
                            <button className="bg-light-gray px-4 py-2 text-white rounded" onClick={() => {
                                setIsDeleteOpen(false)
                                setDeleteChapterValue(null)
                            }}>Cancel</button>
                            <button className="bg-primary px-4 py-2 text-white rounded font-bold" onClick={() => {
                                deleteChapter(deleteChapterValue.id)
                            }}>{isDeleteLoading ? "Deleting..." : "Delete"}</button>
                        </div>
                    </DialogPanel>
                </div>
            </Dialog>

            {/* Add More Groups Modal Dialog */}
            <Dialog open={isAddGroupOpen} onClose={() => setIsAddGroupOpen(false)} className="relative z-50">
                <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center p-4">
                    <DialogPanel className="w-full max-w-6xl max-h-[92vh] overflow-y-auto border bg-white p-6 rounded-lg shadow-xl">
                        <div className="flex items-center justify-between border-b pb-3 mb-4">
                            <DialogTitle className="font-bold text-xl text-black">
                                Add Groups to "{targetChapter?.chapter_name}"
                            </DialogTitle>
                            <button
                                onClick={() => setIsAddGroupOpen(false)}
                                className="text-gray-500 hover:text-black font-bold text-lg px-2"
                            >
                                ✕
                            </button>
                        </div>

                        <Description className="text-sm text-gray-600 mb-4">
                            Search available WhatsApp groups on the left, view existing groups on the right (Read Only), and append new groups.
                        </Description>

                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
                            {/* Left Side: Groups Search & List */}
                            <div className="w-full border p-3 rounded bg-gray-50/50">
                                <p className="font-bold text-base mb-2 text-black">Available Groups to Select</p>
                                <GroupsList
                                    selectedGroupList={selectedNewGroupList}
                                    setSelectedGroupList={setSelectedNewGroupList}
                                />
                            </div>

                            {/* Right Side: Existing Groups (Read Only) & Newly Selected Groups */}
                            <div className="w-full space-y-4">
                                {/* 1. Existing Groups in Fav Group (Read-Only) */}
                                <div className="border p-3 rounded bg-blue-50/30">
                                    <div className="flex items-center justify-between mb-2">
                                        <p className="font-bold text-base text-black flex items-center gap-2">
                                            Existing Groups in "{targetChapter?.chapter_name}" ({existingGroupsList.length})
                                        </p>
                                        <span className="text-xs bg-blue-100 text-blue-800 font-semibold px-2 py-0.5 rounded border border-blue-200">
                                            Read Only
                                        </span>
                                    </div>

                                    <div className="max-h-[190px] overflow-y-auto border rounded bg-white">
                                        <table className="w-full text-sm">
                                            <thead className="bg-light-gray text-white sticky top-0">
                                                <tr>
                                                    <th className="p-[8px] text-left">S No</th>
                                                    <th className="p-[8px] text-left">Group Name</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {existingGroupsLoading ? (
                                                    <tr>
                                                        <td colSpan={2} className="p-4 text-center text-gray-500">
                                                            <Loading />
                                                        </td>
                                                    </tr>
                                                ) : existingGroupsList.length === 0 ? (
                                                    <tr>
                                                        <td colSpan={2} className="p-3 text-center text-gray-500 italic">
                                                            No existing groups found in this Fav Group.
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    existingGroupsList.map((item, index) => (
                                                        <tr key={index} className={`${index % 2 !== 0 ? "bg-input-gray" : ""} border-b`}>
                                                            <td className="p-[8px] text-gray-600">{index + 1}</td>
                                                            <td className="p-[8px] font-medium text-gray-800">
                                                                {item.group_details__group_name}
                                                            </td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                {/* 2. Newly Selected Groups to Add */}
                                <div className="border p-3 rounded bg-green-50/30">
                                    <div className="flex items-center justify-between mb-2">
                                        <p className="font-bold text-base text-black">
                                            Newly Selected Groups to Add ({selectedNewGroupList.length})
                                        </p>
                                    </div>

                                    <div className="max-h-[190px] overflow-y-auto border rounded bg-white">
                                        <table className="w-full text-sm">
                                            <thead className="bg-light-gray text-white sticky top-0">
                                                <tr>
                                                    <th className="p-[8px] text-left">S No</th>
                                                    <th className="p-[8px] text-left">Group Name</th>
                                                    <th className="p-[8px] text-center">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {selectedNewGroupList.length === 0 ? (
                                                    <tr>
                                                        <td colSpan={3} className="p-3 text-center text-gray-500 italic">
                                                            No new groups selected yet. Click groups on the left to add.
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    selectedNewGroupList.map((item, index) => (
                                                        <tr key={index} className={`${index % 2 !== 0 ? "bg-input-gray" : ""} border-b`}>
                                                            <td className="p-[8px]">{index + 1}</td>
                                                            <td className="p-[8px] font-medium text-gray-800">{item.group_name}</td>
                                                            <td className="p-[8px] text-center">
                                                                <button
                                                                    type="button"
                                                                    onClick={() => {
                                                                        setSelectedNewGroupList(
                                                                            selectedNewGroupList.filter(g => g.id !== item.id)
                                                                        );
                                                                    }}
                                                                    className="text-red-600 hover:text-red-800 text-xs font-bold px-2 py-1 bg-red-50 hover:bg-red-100 rounded"
                                                                >
                                                                    Remove
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="flex justify-end gap-3 mt-6 border-t pt-4">
                            <button
                                type="button"
                                disabled={isSavingNewGroups}
                                onClick={() => setIsAddGroupOpen(false)}
                                className="bg-light-gray px-4 py-2 text-white rounded font-medium text-sm hover:opacity-90"
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                disabled={isSavingNewGroups}
                                onClick={handleAddGroupsSubmit}
                                className="bg-primary px-5 py-2 text-white rounded font-semibold text-sm hover:bg-primary-dark transition"
                            >
                                {isSavingNewGroups ? "Saving Groups..." : `Save Groups (${selectedNewGroupList.length})`}
                            </button>
                        </div>
                    </DialogPanel>
                </div>
            </Dialog>
        </>
    );
}